import { render, staticRenderFns } from "./FieldEditValidationRule.vue?vue&type=template&id=0ebadfb4&"
import script from "./FieldEditValidationRule.vue?vue&type=script&lang=js&"
export * from "./FieldEditValidationRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports